import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Boxes, Briefcase, Inbox, Activity } from "lucide-react";
import { api, asArray } from "@/lib/api";

const Card = ({ icon: Icon, label, value, hint, to, testId }) => (
  <Link
    to={to}
    className="kt-card p-6 block"
    data-testid={testId}
  >
    <div className="flex items-start justify-between">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-[#52525B]">
          {label}
        </div>
        <div className="kt-stat text-4xl mt-3 text-[#18181B]">{value}</div>
        {hint && <div className="text-xs text-[#52525B] mt-2">{hint}</div>}
      </div>
      <div className="w-10 h-10 bg-[#0F172A] text-white grid place-items-center">
        <Icon size={18} />
      </div>
    </div>
  </Link>
);

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [inquiries, setInquiries] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => setStats(null));
    api.get("/admin/inquiries").then((r) => setInquiries(asArray(r.data).slice(0, 5))).catch(() => setInquiries([]));
  }, []);

  return (
    <div className="space-y-8" data-testid="admin-dashboard">
      <div>
        <div className="kt-eyebrow">Ringkasan</div>
        <h1 className="font-display text-3xl font-bold mt-2">Dashboard</h1>
        <p className="text-sm text-[#52525B] mt-2">
          Pantauan singkat aktivitas website CV. Komunika Teknik.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        <Card
          icon={Boxes}
          label="Layanan"
          value={stats?.services ?? "—"}
          to="/admin/services"
          hint="Kelola daftar layanan"
          testId="stat-card-services"
        />
        <Card
          icon={Briefcase}
          label="Portfolio"
          value={stats?.portfolios ?? "—"}
          to="/admin/portfolios"
          hint="Kelola proyek"
          testId="stat-card-portfolios"
        />
        <Card
          icon={Inbox}
          label="Inquiry Baru"
          value={stats?.inquiries?.new ?? "—"}
          to="/admin/inquiries"
          hint={`${stats?.inquiries?.total ?? 0} total inquiry`}
          testId="stat-card-new-inquiries"
        />
        <Card
          icon={Activity}
          label="Responded"
          value={stats?.inquiries?.responded ?? "—"}
          to="/admin/inquiries"
          hint="Total ditangani"
          testId="stat-card-responded"
        />
      </div>

      <div className="kt-card p-6 md:p-8" data-testid="recent-inquiries-panel">
        <div className="flex items-center justify-between mb-6">
          <div>
            <div className="kt-eyebrow">Aktivitas</div>
            <h2 className="font-display font-bold text-xl mt-1">
              Inquiry Terbaru
            </h2>
          </div>
          <Link
            to="/admin/inquiries"
            className="text-xs uppercase tracking-[0.16em] font-semibold text-[#DC2626]"
            data-testid="view-all-inquiries-link"
          >
            Lihat Semua →
          </Link>
        </div>
        <div className="border border-[#E4E4E7]">
          <table className="w-full text-sm">
            <thead className="bg-[#FAFAFA] border-b border-[#E4E4E7]">
              <tr className="text-left text-xs uppercase tracking-[0.14em] text-[#52525B]">
                <th className="px-4 py-3">Nama</th>
                <th className="px-4 py-3">Email</th>
                <th className="px-4 py-3">Layanan</th>
                <th className="px-4 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {inquiries.map((i) => (
                <tr
                  key={i.id}
                  className="border-b border-[#E4E4E7] last:border-0"
                  data-testid={`recent-inquiry-row-${i.id}`}
                >
                  <td className="px-4 py-3 font-medium">{i.name}</td>
                  <td className="px-4 py-3 text-[#52525B]">{i.email}</td>
                  <td className="px-4 py-3 text-[#52525B]">{i.service_type}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`text-[10px] uppercase tracking-[0.16em] font-bold px-2 py-1 ${
                        i.status === "new"
                          ? "bg-[#DC2626] text-white"
                          : i.status === "responded"
                          ? "bg-[#0369A1] text-white"
                          : "bg-[#F4F4F5] text-[#18181B]"
                      }`}
                    >
                      {i.status}
                    </span>
                  </td>
                </tr>
              ))}
              {inquiries.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-4 py-8 text-center text-[#52525B]">
                    Belum ada inquiry.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
